import React, { Component } from 'react';
import { connect } from 'react-redux';
import withRouter from '../../../lib/router/withRouter';
import { message } from 'antd';
import RemoteImageSplashDetailWrap from '../../../views/remoteImage/splash/detail/RemoteImageSplashDetailWrap';
import { remoteImageActions } from '../../../store/modules/remoteImage';
import { REMOTE_IMAGE_SPLASH_DETAIL_MODEL } from '../../../store/modules/remoteImage/models';
import {
  REMOTE_IMAGE_ACTIVE_STATUS_TYPE,
  REMOTE_IMAGE_DETAIL_PAGE_TYPE,
  REMOTE_IMAGE_TYPE,
  REMOTE_IMAGE_TYPE_TEXT,
} from '../../../constants/service/app/remoteImageConstants';
import { remoteImageActiveConfirm, remoteImageInActiveConfirm } from '../../../lib/utils/RemoteImageUtils';

class RemoteImageSplashDetailContainer extends Component {
  componentDidMount() {
    const { match } = this.props;

    if (match.params.id) {
      this.initiate(Number(match.params.id));
    }
  }

  componentWillUnmount() {
    const { setData } = this.props;

    /**
     *  데이터 초기화
     */
    setData({
      path: ['remoteImageSplashDetail'],
      value: REMOTE_IMAGE_SPLASH_DETAIL_MODEL,
    });
  }

  /**
   * 초기 데이터 불러오기
   */
  initiate = (remoteImageId) => {
    const { getRemoteImageSplashDetail } = this.props;

    getRemoteImageSplashDetail({
      remoteImageId,
    });
  };

  onSubmit = async () => {
    const { match, detailPageType, remoteImageSplashDetail, createRemoteImageSplash, editRemoteImageSplash } =
      this.props;
    const { remoteImg, memo, imgUrl, status, originStatus } = remoteImageSplashDetail;

    if (!remoteImg.length) {
      message.error('이미지는 필수 값 입니다.');
      return;
    }

    let confirmResult = true;

    /**
     *  원격 이미지 등록
     */
    if (detailPageType === REMOTE_IMAGE_DETAIL_PAGE_TYPE.CREATE) {
      /**
       *  활성 상태인 경우 확인 모달 노출
       */
      if (status === REMOTE_IMAGE_ACTIVE_STATUS_TYPE.ACTIVE) {
        confirmResult = await remoteImageActiveConfirm({
          remoteImageTypeName: REMOTE_IMAGE_TYPE_TEXT[REMOTE_IMAGE_TYPE.SPLASH],
        });
      }

      /**
       *  확인 모달에서 취소할 경우
       *  등록 중지
       */
      if (!confirmResult) return;

      createRemoteImageSplash({
        remoteImg,
        status,
        memo,
      });
    } else if (detailPageType === REMOTE_IMAGE_DETAIL_PAGE_TYPE.EDIT) {
      /**
       *  원격 이미지 수정
       */
      /**
       *  상태가 변경된 경우
       */
      if (originStatus !== status) {
        /**
         *  비활성 -> 활성
         */
        if (status === REMOTE_IMAGE_ACTIVE_STATUS_TYPE.ACTIVE) {
          confirmResult = await remoteImageActiveConfirm({
            remoteImageTypeName: REMOTE_IMAGE_TYPE_TEXT[REMOTE_IMAGE_TYPE.SPLASH],
          });
        } else if (status === REMOTE_IMAGE_ACTIVE_STATUS_TYPE.IN_ACTIVE) {
          /**
           *  활성 -> 비활성
           */
          confirmResult = await remoteImageInActiveConfirm({
            remoteImageTypeName: REMOTE_IMAGE_TYPE_TEXT[REMOTE_IMAGE_TYPE.SPLASH],
          });
        }
      }

      /**
       *  확인 모달에서 취소할 경우
       *  편집 중지
       */
      if (!confirmResult) return;

      editRemoteImageSplash({
        remoteImageId: match.params.id ? Number(match.params.id) : undefined,
        remoteImg,
        memo,
        status: originStatus !== status ? status : originStatus,
        beforeImgUrl: imgUrl,
      });
    }
  };

  /**
   *  url 복사하기
   */
  copyUrl = (url) => {
    navigator.clipboard.writeText(url);
    message.success('복사가 완료되었습니다.');
  };

  render() {
    const { pageType, detailPageType, remoteImageSplashDetail, setData } = this.props;

    return (
      <RemoteImageSplashDetailWrap
        pageType={pageType}
        detailPageType={detailPageType}
        remoteImageSplashDetail={remoteImageSplashDetail}
        setData={setData}
        onSubmit={this.onSubmit}
        copyUrl={this.copyUrl}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    remoteImageSplashDetail: state.remoteImage.remoteImageSplashDetail,
  };
};

const mapDispatchToProps = {
  setData: remoteImageActions.setData,
  getRemoteImageSplashDetail: remoteImageActions.getRemoteImageSplashDetail,
  createRemoteImageSplash: remoteImageActions.createRemoteImageSplash,
  editRemoteImageSplash: remoteImageActions.editRemoteImageSplash,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(RemoteImageSplashDetailContainer));
